import { useEffect, useState } from 'react';

// Step1Form with date and time fields
const Step1 = ({ register, errors, watch, setValue }) => {
  // Format date and time to YYYY-MM-DDThh:mm for datetime-local inputs
  const formatDateTimeForInput = (dateTimeString) => {
    if (!dateTimeString) return '';
    
    // Handle YYYY/MM/DD HH:MM format
    if (dateTimeString.includes('/')) {
      const [datePart, timePart = '00:00'] = dateTimeString.split(' ');
      const [year, month, day] = datePart.split('/');
      return `${year}-${month}-${day}T${timePart}`;
    }
    
    return dateTimeString;
  };

  // Parse date and time from input and format to YYYY/MM/DD HH:MM
  const handleDateTimeChange = (e, fieldName) => {
    if (e.target.value) {
      const [datePart, timePart] = e.target.value.split('T');
      const [year, month, day] = datePart.split('-');
      setValue(fieldName, `${year}/${month}/${day} ${timePart || '00:00'}`);
    } else {
      setValue(fieldName, '');
    }
  };

  return (
    <div className="space-y-6">
      {/* Basic fields */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xxl:grid-cols-4 gap-4">
        {/* name field */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">
            活動名稱
            <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            {...register('name', { 
              required: '活動名稱為必填欄位'
            })}
            className={`w-full p-2 border rounded ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
          />
          {errors.name && (
            <p className="text-red-500 text-sm">{errors.name.message}</p>
          )}
        </div>

        {/* isEnabled field */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">
            是否啟用
            <span className="text-red-500 ml-1">*</span>
          </label>
          <select
            {...register('isEnabled', { 
              required: '是否啟用為必填欄位'
            })}
            className={`w-full p-2 border rounded ${errors.isEnabled ? 'border-red-500' : 'border-gray-300'}`}
          >
            <option value="">請選擇</option>
            <option value="true">啟用</option>
            <option value="false">停用</option>
          </select>
          {errors.isEnabled && (
            <p className="text-red-500 text-sm">{errors.isEnabled.message}</p>
          )}
        </div>

        {/* startAt field - now with date and time */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">起始日期及時間</label>
          <input
            type="datetime-local"
            value={formatDateTimeForInput(watch('startAt'))}
            onChange={(e) => handleDateTimeChange(e, 'startAt')}
            className={`w-full p-2 border rounded ${errors.startAt ? 'border-red-500' : 'border-gray-300'}`}
          />
          {errors.startAt && (
            <p className="text-red-500 text-sm">{errors.startAt.message}</p>
          )}
        </div>

        {/* endAt field - now with date and time */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">結束日期及時間</label>
          <input
            type="datetime-local"
            value={formatDateTimeForInput(watch('endAt'))}
            onChange={(e) => handleDateTimeChange(e, 'endAt')}
            className={`w-full p-2 border rounded ${errors.endAt ? 'border-red-500' : 'border-gray-300'}`}
          />
          {errors.endAt && (
            <p className="text-red-500 text-sm">{errors.endAt.message}</p>
          )}
        </div>

        {/* utc field */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">UTC 時區值</label>
          <input
            {...register('utc', {
              pattern: {
                value: /^-?([0-9]|1[0-2])$/,
                message: '請輸入有效的 UTC 時區值 (-12 至 12)'
              }
            })}
            className={`w-full p-2 border rounded ${errors.utc ? 'border-red-500' : 'border-gray-300'}`}
          />
          {errors.utc && (
            <p className="text-red-500 text-sm">{errors.utc.message}</p>
          )}
        </div>

        {/* venue field */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">地點（venue）</label>
          <input
            {...register('venue')}
            className="w-full p-2 border rounded border-gray-300"
          />
        </div>

        {/* location field */}
        <div className="space-y-1">
          <label className="block text-sm font-medium">地點（location）</label>
          <input
            {...register('location')}
            className="w-full p-2 border rounded border-gray-300"
          />
        </div>
      </div>
    </div>
  );
};

export default Step1;